<ng-container>
  <!-- Show split button when a query is selected -->
  <ng-container>
    <!-- <nz-button-group> -->
      <button
        type="button"
        nz-button
        nzType="primary"
        [nzSize]="buttonSize"        
      
        [ngClass]="{ 'disabled-button': disableSave || !selectedQuery || updating }"

        (click)="updateQuery()"
        nz-tooltip="Update Query"        
      >
        <i nz-icon nzType="edit" nzTheme="outline" ></i>
        <!-- <img   [src]="'assets/outline/update-query.svg'"> -->
      </button>
      <!-- <button
        type="button"
        nz-button
        nzType="primary"
        [nzSize]="buttonSize"
        [disabled]="disableSave"
        nz-dropdown
        [nzDropdownMenu]="saveMenu"
        nzPlacement="bottomRight"
      >
        <i nz-icon nzType="down"></i>
      </button> -->
    <!-- </nz-button-group>   -->
  </ng-container>

  <!-- Show regular save button when no query is selected -->
  <!-- <ng-template #saveOnlyButton> -->
    <button
      type="button"
      nz-button
      nzType="primary"
      class="ml-sm"
      [nzSize]="buttonSize"
      [disabled]="disableSave"
      (click)="saveQuery()"
     nz-tooltip="Save Query"
      [nzTooltipTitle]="showLabels ? '' : 'Save Query'"
    >
      <i nz-icon nzType="plus" nzTheme="outline" ></i>
      <!-- <img   [src]="'assets/outline/Save-Query.svg'"> -->
    </button>
  <!-- </ng-template> -->

  <button
    type="button"
    nz-button
    nzType="primary"
    [nzSize]="buttonSize"
    (click)="openSavedQueries()"
    class="ml-sm"
    nz-tooltip="My Saved Queries"    
  >
    <i nz-icon nzType="folder-open" nzTheme="outline"></i>
    <!-- <span *ngIf="showLabels"></span> -->
    <!-- <img   [src]="'assets/outline/My-Query.svg'"> -->
  </button>
</ng-container>
